import React, { useState, useEffect } from 'react';
import { Avatar, IconButton } from '@mui/material';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import CloseIcon from '@mui/icons-material/Close'; // Import MUI Close Icon

export default function AvatarUploader({ id, image, setImage }) {
    const [defaultImage, setdefaultImage] = useState()

    useEffect(() => {
        if (image && typeof image === 'string' && image.includes('http')) {
            setdefaultImage(image);
        }
    }, [image]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImage(file);
        }
    };

    const handleReset = () => {
        setImage(defaultImage)
    };

    return (
        <div style={{ textAlign: 'center', position: 'relative' }}>
            <input
                accept="image/*"
                style={{ display: 'none' }}
                id={"upload-image-" + id}
                type="file"
                onChange={handleImageChange}
            />
            <label htmlFor={"upload-image-" + id}>
                <IconButton color="primary" aria-label="upload picture" component="span">
                    <Avatar
                        src={image instanceof File ? URL.createObjectURL(image) : image}
                        alt="User profile"
                        sx={{ width: 100, height: 100 }}
                    />
                    <PhotoCamera style={{ position: 'absolute', bottom: 0, right: 0 }} />
                </IconButton>
            </label>
            {image != defaultImage && (
                <IconButton
                    onClick={handleReset}
                    style={{ position: 'absolute', top: 0, color: 'red' }}
                    aria-label="reset picture"
                >
                    <CloseIcon />
                </IconButton>
            )}
        </div>
    );
};
